/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommonModule } from '@angular/common';
import { Component, ContentChildren, inject, QueryList } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Data } from '@angular/router';
import { map } from 'rxjs';
import { WizardStepComponent } from './wizard-step/wizard-step.component';

@Component({
  selector: 'ods-wizard',
  imports: [CommonModule],
  template: `
    <div class="mb-4 flex" role="list">
      @for (stepComponent of stepComponents.toArray(); let i = $index; track $index) {
        <div
          class="flex-1 border-b-2 px-4 py-2"
          [ngClass]="{ 'border-primary text-primary font-bold': activeStep() === i }"
          [attr.aria-current]="activeStep() === i ? 'step' : null"
          role="listitem"
        >
          {{ stepComponent.label }}
        </div>
      }
    </div>
    @if (stepComponents.get(activeStep())?.content; as content) {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    }
  `,
})
export class WizardComponent {
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  public readonly activeStep = toSignal(this.activatedRoute.data.pipe(map((data: Data) => data[WIZARD_TAB])));

  @ContentChildren(WizardStepComponent)
  public stepComponents: QueryList<WizardStepComponent>;
}

export const WIZARD_TAB: string = 'tab';
